import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import httpFactory from "@/utils/http";
import storeBuild from "@/utils/store";
import actionTool from "@/utils/action";
import plugins from "@/utils/plugins";
import LimitModal from "./views/exam/components/LimitModal";
Vue.config.bjy_player = null;

import kefu from '../../utils/customer'
import "../../utils/extension";
import "../../utils/filter";
import "../../utils/highlight";
import "./video";
import ServiceInject from "@/services/ServiceInject";
import lang from "../../lang";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
Vue.component("LimitModal", LimitModal);
Vue.prototype.$actionTool = { ...actionTool, ...plugins };
const i18n = new VueI18n({
  locale: "cn",
  messages: lang.message,
});

Vue.config.productionTip = false;
Vue.config.login_flag = false;
Vue.config.school_flag = false;

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper);

import ScaleImage from "@/components/ScaleImage.vue";
Vue.component("ScaleImage", ScaleImage);

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload);

import ImageClip from "@/components/ImageClip.vue";
Vue.component("ImageClip", ImageClip);

let vue;
const http = httpFactory.build("student");
Vue.prototype.$http = http;

Vue.prototype.$kefu = kefu;

http.beforeRequest = function (isAuthRequest, showLoading) {
  if (isAuthRequest) {
    if (!store.state.token) {
      Vue.prototype.$LoginModal.login({ type: "passwordLogin", store: store });
      return false;
    }
  }
  if (showLoading) {
    store.commit("setLoading", true);
  }
  return true;
};
http.afterRequest = function () {
  store.commit("setLoading", false);
};
http.onApiError = function (data) {
  if (data.code == 202) {
    if (!Vue.config.login_flag) {
      Vue.config.login_flag = true;
      vue.$error(data.msg).then(() => {
        store.commit("logout");
        store.commit("clearSchoolInfo");
        Vue.prototype.$LoginModal.login({
          type: "passwordLogin",
          store: store,
        });
        Vue.config.login_flag = false;
      });
    }
  } else if (data.code == 205) {
    if (!Vue.config.school_flag) {
      Vue.config.school_flag = true;
      vue
        .$alert(data.msg, {
          showClose: false,
        })
        .then(() => {
          Vue.config.school_flag = false;
          store.commit("setSchoolID", store.state.user_info.origin_school_id);
          window.location.href = "/";
        });
    }
  } else if (data.msg == "你来晚了哦,名额已经没有了~") {
    vue.$alert(data.msg, "提示");
  } else {
    vue.$message.error(data.msg);
  }
};

const store = storeBuild(http, "student", async context => {
  if (!context.state.token) {
    return;
  }
  let data = await http.get("/api/app/userInfo");
  data.sex = data.sex.toString();
  context.commit("setUser", data);
});

// 自定义弹框登录
import LoginModal from "@/components/LoginModal/LoginModal.js";
// identity
import Identity from "@/utils/identity";
Vue.prototype.$identity = new Identity("student", store.state);
Vue.prototype.$LoginModal = LoginModal;

async function refreshSetting(routeTo) {
  if (routeTo.name != "Login" && !store.state.school_info.cur_school_id) {
    await store.dispatch("getSchoolInfo");
  }
  if (store.state.webConfig.web_title) {
    document.title = plugins.getTitle(store.state.webConfig.web_title, routeTo);
  } else {
    await store.dispatch("getWebConfig", routeTo);
    await store.dispatch("getOtherSetting");
  }
}

router.beforeEach(async (to, from, next) => {
  let schoolId = to.query.school_id;
  //如果跳转到vip页面，但是会员关闭
  if (to.name == "Vip") {
    await store.dispatch("getWebConfig", to);
    if (!store.getters.showVip)
      next({
        name: "Index",
      });
  }
  // 解决离开播放页，视频依然在播放的问题
  if (from.name == "Video") {
    if (Vue.config.bjy_player && Vue.config.bjy_player.duration) {
      Vue.config.bjy_player.pause();
      Vue.config.bjy_player.destroy();
      window.$("#video-wrap").html("");
    }
  }
  if (schoolId) {
    store.commit("setSchoolID", schoolId);
    let query = { ...to.query };
    delete query.school_id;
    let { href } = router.resolve({ name: to.name, params: to.params, query });
    window.location = href;
    return;
  }
  await store.dispatch("getNavigator");
  if (to.name == "Index") {
    await refreshSetting(to);
    await store.dispatch("getIndexData");
    let indexData = store.state.indexData;
    if (
      indexData.bannerList.length == 0 &&
      indexData.recommendList.length == 0
    ) {
      let navigate = store.state.navigates[0];
      if (navigate && navigate.is_outer == 0) {
        let url = navigate.url;
        if (url == "/index") {
          next();
          return;
        }
        if (url.indexOf("?") < 0) {
          url += "?";
        } else {
          url += "&";
        }
        url += "nav=" + navigate.id;
        router.push({ path: url });
        return;
      }
    }
  }
  if (from.name != "ForgotPassword" && from.name != "Login") {
    to.query.relogin = from.name;
  } else {
    to.query.relogin = "";
  }
  if (to.name != "ForgotPassword" && to.name != "Login") {
    sessionStorage.loginBack = to.path;
  }
  await refreshSetting(to);

  if (to.meta.requireAuth) {
    if (store.state.token) {
      next();
    } else {
      Vue.prototype.$LoginModal.login({ type: "passwordLogin", store: store });
    }
  } else {
    next();
  }
  window.scrollTo(0, 0);
});
Vue.prototype.$store = store;
vue = new Vue({
  router,
  store: store,
  i18n,
  render: h => h(App),
});

ServiceInject(http, vue, store, router);
//action中传入vue实例
import { use as actionUse } from "@/utils/action.js";
actionUse(vue);
vue.$mount("#app");
